module.exports = __webpack_public_path__ + "static/media/Urban Colors Art_1.b2914cd7.jpg";